import styled from '@emotion/styled'
import { Form } from 'antd'
import { InjectedFormProps, reduxForm } from 'redux-form'
import Button from '../../../components/common/Button'
import Text from '../../../components/common/Text'
import { InputField, SwitchField } from '../../../components/common/fields'
import { SHOP_PRIMARY } from '../../../constant/colors'
import { mobile } from '../../../utils/responsive-helper'
import { AddressValues } from '../../../services/address/address-typed'

const FormLayout = styled(Form)`
  width: 100%;
  height: fit-content;

  ${mobile} {
    height: calc(100vh - 64px - 8px - 16px - 136px);
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: scroll;
  }
`

const Content = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  ${mobile} {
    flex-flow: column;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  justify-content: center;
  margin-bottom: 16px;
`

const InputFieldStyled = styled(InputField)`
  width: 100%;
  border-radius: 4px;
`

const FlexSubmit = styled.div`
  ${mobile} {
    width: 100%;
    height: 136px;
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    left: 0;
    background: white;
    padding: 16px;
  }
`

const DefaultAddressStyle = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 0;

  ${mobile} {
    padding: 0 0 28px 0;
  }
`

const SubmitButton = styled(Button)`
  width: 100%;
  max-width: 100%;
  border-radius: 100px;
`

type AddressFormProps = InjectedFormProps<AddressValues>

const enchancer = reduxForm<AddressValues, {}, any>({
  form: 'AddressForm',
  validate: () => {
    const error: Partial<AddressValues> = {}
    return error
  },
})

const required = (value: string) => (value ? undefined : 'error.required')
const AddressForm = (props: AddressFormProps) => {
  const { handleSubmit } = props

  return (
    <FormLayout>
      <Content>
        <FlexRow className="name">
          <InputFieldStyled required name="name" label="ชื่อ-นามสกุล" validate={[required]} />
        </FlexRow>
        <FlexRow className="street">
          <InputFieldStyled required name="street" label="ที่อยู่" validate={[required]} />
        </FlexRow>
        <FlexRow className="subDistrict">
          <InputFieldStyled required name="subDistrict" label="ตำบล/แขวง" validate={[required]} />
        </FlexRow>
        <FlexRow className="district">
          <InputFieldStyled required name="district" label="อำเภอ/เขต" validate={[required]} />
        </FlexRow>
        <FlexRow className="province">
          <InputFieldStyled required name="province" label="จังหวัด" validate={[required]} />
        </FlexRow>
        <FlexRow className="postcode">
          <InputFieldStyled
            required
            name="postcode"
            label="รหัสไปรษณีย์"
            maxLength={5}
            validate={[required]}
          />
        </FlexRow>
        <FlexRow className="phoneNumber">
          <InputFieldStyled name="phoneNumber" label="หมายเลขโทรศัพท์" maxLength={10} />
        </FlexRow>
      </Content>
      <FlexSubmit>
        <DefaultAddressStyle>
          <Text>เลือกเป็นที่อยู่ตั้งต้น</Text>
          <SwitchField name="defaultAddress" />
        </DefaultAddressStyle>
        <SubmitButton background={SHOP_PRIMARY} onClick={handleSubmit}>
          บันทึกที่อยู่นี้
        </SubmitButton>
      </FlexSubmit>
    </FormLayout>
  )
}

export default enchancer(AddressForm)
